module.exports = __webpack_public_path__ + "media/images/version_merge/target_portfolio-d9ff8334d17002b3a1fd700c8532a529.jpg";